import React from "react";
import { Redirect } from "react-router-dom";
import settings from "../settings";
import FetchResponses from "./FetchResponses";
import Logger from "./Logger";

class AdminRedirect extends React.Component {
  state = {
    redirectUrl: null,
    error: false,
  };

  componentDidMount() {
    fetch(settings.backend.modules, {
      method: "GET",
      headers: settings.headers_auth(localStorage.getItem("session_token")),
    })
      .then(FetchResponses.processResponse)
      .then((response) => {
          let module = settings.authenticated_admin_page;
          if (response.modules && response.modules.length > 0) {
              module = response.modules[0].url;
            }
        this.setState({ redirectUrl: module });
      })
      .catch((err) => {
        console.log("Error fetching modules", err);
        this.setState({ error: true });
      });
  }

  render() {
    const { redirectUrl, error } = this.state;

    

    if (redirectUrl) {
      return <Redirect to={redirectUrl} />;
    }

    return null; // o null si no quieres mostrar nada
  }
}

export default AdminRedirect;
